export default __webpack_public_path__ + "static/fireJuliet-afd614db4c44d7f53f2c4bfc5ddca43d.png";